import React from "react";
import { Container, Form, Button, Card } from "react-bootstrap";
import Logo  from "../assets/images/logo.png";
import Google  from "../assets/images/google.svg";
import Apple  from "../assets/images/apple.svg";
import { useNavigate } from 'react-router-dom';

function Register() {
    const navigate = useNavigate();
    const [error, setError] = React.useState('');
    const [email, setEmail] = React.useState('');

    const handleContinue = () => {
      if (email) {
        setError('');
        navigate("/create-account-continue", { state: { email } });
      }else{
        setError('Email is required');
      }
    };

  return (
    <div className="login-sign-main common-padding" >
      <Container>
        <Card>
          <div className="login-sign-wrap">
            <img width={160} src={Logo} alt="" />
            <h3>Create account</h3>
          </div>

          <Form>
            <Form.Group controlId="formBasicEmail">
              <Form.Control type="email" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </Form.Group>

            <Button className="custom-bttn style-3 w-100 mt-3" onClick={handleContinue}>
              Continue
            </Button>
            <p className="text-danger">
              {error}
            </p>

            <p className="mb-0">
             Have a Jambobay account?{" "}
              <a href="/sign-in">
                Sign in
              </a>
            </p>
            
            <div className="text-center or-div"> </div>

            {/* <div
              className="text-center or-div"
            >
              <span>
                OR
              </span>
            </div>

            <Button className="custom-bttn style-2 w-100 mb-3">
              <img src={Google} alt="" />
              Continue with Google
            </Button>

            <Button className="custom-bttn style-2 w-100">
              <img src={Apple} alt="" />
              Continue with Apple
            </Button> */}

            <p className="mb-0">
              By submitting, I accept RealEstate{" "}
              <a href="/terms-of-use">
                terms of use
              </a>
            </p>
          </Form>
        </Card>
      </Container>
    </div>
  );
}

export default Register;
